const html = document.documentElement;

const setOverflow = () => {
    html.dataset.noScroll = '';
};

const unsetOverflow = () => {
    delete html.dataset.noScroll;
};

export { setOverflow, unsetOverflow };
